import styled from 'styled-components';
import { Flex } from 'components/Flex';
import { BKJButton } from '@bookjane2/bookjane-design-library';

export const AllowOvertimeToggleInputLabel = styled.span`
  margin-right: 12px;
  ${({ theme }) => theme.typography.Body};
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
export const AllowOvertimeToggleInputWrapper = styled(Flex)`
  margin-left: 30px;
  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    margin: 8px 0 0 0;
    padding: 12px 0;
  }
`;

export const ShiftCardButtonWithNoHeight = styled(BKJButton)`
  width: fit-content;
  min-height: fit-content;
  &:not(:first-child) {
    margin-left: 30px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
